import { render, staticRenderFns } from "./PortDashboard.vue?vue&type=template&id=0ad541a6&"
import script from "./PortDashboard.vue?vue&type=script&lang=ts&"
export * from "./PortDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports